import { createAction, createAsyncThunk } from '@reduxjs/toolkit';

import { USER_ROLES } from 'constants/common';

import * as api from 'api/methods';

import * as types from './types';

export const getTrainings = createAsyncThunk<any, any>(
  types.GET_TRAININGS,
  async (params: Record<string, any>, { getState }: { getState: any }) => {
    const state = getState() as any;

    const user = state.auth.user;

    const isRootAdmin = user.role === USER_ROLES.ROOT_ADMIN;

    const trainings = isRootAdmin
      ? await api.getTrainings(params)
      : await api.getSchoolTrainings({ schoolId: user.schoolId, params });

    return trainings;
  },
);

export const getSchoolTrainings = createAsyncThunk<any, any>(
  types.GET_SCHOOL_TRAININGS,
  async (data: any) => {
    const trainings = await api.getSchoolTrainings(data);

    return trainings;
  },
);

export const updateTrainingById = createAsyncThunk<any, any>(
  types.UPDATE_TRAINING_BY_ID,
  async ({
    trainingId,
    fieldName,
    data,
  }: {
    trainingId: string;
    fieldName: any;
    data: any;
  }) => {
    const training = await api.updateTrainingById({ trainingId, data });

    return { fieldName, updatedTraining: training };
  },
);

export const removeTrainingById = createAction(types.REMOVE_TRAINING_BY_ID);
